import Glide from '@glidejs/glide';

const sliderVisuals = document.querySelectorAll('.slider-visual');
const sliderMultiple = document.querySelectorAll('.slider-multiple');

// @TODO:
// - Nice to have: Switch to modular esm build for tree shaking purposes

if (sliderVisuals.length) {
  sliderVisuals.forEach((slider) => {
    const instance = new Glide(slider, {
      type: 'carousel',
      autoplay: false,
      keyboard: false,
      perView: 1,
      perTouch: 1,
    }).mount();

    if ('sliderDisableInteraction' in slider.dataset) {
      instance.disable();
    }
  });
}

if (sliderMultiple.length) {
  sliderMultiple.forEach((slider) => {
    new Glide(slider, {
      type: 'carousel',
      autoplay: false,
      keyboard: false,
      perView: slider.dataset.glidePerView ? parseInt(slider.dataset.glidePerView, 10) : 2,
      perTouch: slider.dataset.glidePerView ? parseInt(slider.dataset.glidePerView, 10) : 2,
      gap: 40,
      breakpoints: {
        991: {
          perView: 2,
          perTouch: 2,
        },
        767: {
          perView: 1,
          perTouch: 1,
        },
      },
    }).mount();
  });
}
